const SHOPPING_CART_ID = 'BOARDING_OPTIONS';

const processIds = ([id] = []) => ({
    ...(id && {id}),
});

const decorate = (data = {}) => {
    const {selection = {}} = data;

    return {
        ...data,
        id: SHOPPING_CART_ID,
        selection,
    };
};

module.exports = {
    decorate,
    processIds,
    getProductName: () => SHOPPING_CART_ID,
};
